import { render, staticRenderFns } from "./CrossProductItem.vue?vue&type=template&id=4f1019ba&"
import script from "./CrossProductItem.vue?vue&type=script&lang=js&"
export * from "./CrossProductItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpusButton: require('/~/src/modules/opus/components/Form/Button.vue').default,OpusCard: require('/~/src/modules/opus/components/Card.vue').default,InsuranceProductModal: require('/~/src/modules/opus-ecom/components/Catalog/InsuranceProductModal.vue').default})
